import { render } from "./EditPerformanceManagement.vue?vue&type=template&id=badf5cba&scoped=true"
import script from "./EditPerformanceManagement.vue?vue&type=script&lang=js"
export * from "./EditPerformanceManagement.vue?vue&type=script&lang=js"

import "./EditPerformanceManagement.vue?vue&type=style&index=0&id=badf5cba&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badf5cba"]])

export default __exports__